import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { PostUserUnsubscribe } from '../domain/dtos/post-user-unsubscribe'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class PostUnsubscribeNotification {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient<void>,
  ) {}

  public async execute(input: PostUserUnsubscribe): Promise<void> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.BFF_MEMBERS_AREA_URL}/public/user/unsubscribe/${input.token}`,
    })

    if (response.statusCode === HttpStatusCode.CREATED || response.statusCode === HttpStatusCode.OK) {
      return
    }

    throw new GeneralError()
  }
}
